// Generic parser for the localStorage shape used by per-industry filter state:
//   Record<industryId, FilterPayload>
// Pre-scoped flat shape (no industry wrapper) is treated as invalid and discarded so callers
// can fall back to a clean state instead of mixing legacy + new shapes.
export const parseIndustryScopedFilterMap = (raw: string | null): Record<string, Record<string, unknown>> => {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
    const entries = Object.entries(parsed as Record<string, unknown>);
    if (entries.length === 0) return {};
    const isIndustryScoped = entries.every(
      ([k, v]) => /^\d+$/.test(k) && v !== null && typeof v === "object" && !Array.isArray(v),
    );
    return isIndustryScoped ? (parsed as Record<string, Record<string, unknown>>) : {};
  } catch {
    return {};
  }
};
